<template>
    <div class="flex mt-3 w-full" @click="clickTab()">
        <div class="cursor-pointer text-green-1 text-18">
            {{lbl.detail.condition}}
        </div>
        <img class="mr-0 ml-auto h-3" v-show="!active" src="@/assets/icon/ic-arrow-down.svg" alt="" />
        <img class="mr-0 ml-auto h-3" v-show="active" src="@/assets/icon/ic-arrow-up.svg" alt="" />
    </div>
    <div class="pt-3" v-show="active">
        <div class="text-gray-1 border-t border-gray-2 pt-4 text-18"  v-html="conditionText"></div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "Condition",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    data: function() {
        return {
            active: true, // detail, condition
            conditionText: null,
        };
    },
    created: function() {
        this.conditionText = Util.newLineToBr(this.campaign.condition);
    },
    methods: {
        clickTab: function() {
            this.active = !this.active;
        },
    }
}
</script>
